module.exports = __webpack_public_path__ + "static/media/WhiteStreetLogo.96202e20.png";